<template>
    <v-dialog
        @click:outside="closeSearchDialog"
        :value="isOpenSearchDialog"
        max-width="500"
    >
        <ValidationObserver
            v-if="isOpenRegisters"
            ref="obs"
            v-slot="{ handleSubmit }"
        >
            <v-card>
                <v-card-title class="pa-0 shadow-1">
                    <v-img
                        :src="
                            require('@/assets/illustrations/bg_modal_card.svg')
                        "
                        cover
                        position="left bottom"
                        class="align-center"
                        height="65px"
                    >
                        <v-card-title class="font-weight-medium primary--text">
                            Búsqueda de registro
                        </v-card-title>
                    </v-img>
                </v-card-title>

                <v-card-text class="mb-5">
                    <v-form>
                        <v-row>
                            <v-col cols="12">
                                <ValidationProvider
                                    name="Numero"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <v-radio-group
                                        v-model="searchType"
                                        :error-messages="errors"
                                        row
                                    >
                                        <v-radio
                                            label="DNI"
                                            value="dni"
                                        ></v-radio>
                                        <v-radio
                                            label="Telefono"
                                            value="phone"
                                        ></v-radio>
                                    </v-radio-group>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12">
                                <ValidationProvider
                                    :name="
                                        searchType === 'dni'
                                            ? 'DNI'
                                            : 'Numero de teléfono'
                                    "
                                    rules="required|numeric"
                                    v-slot="{ errors }"
                                >
                                    <v-text-field
                                        v-model="searchQueryDialog"
                                        :error-messages="errors"
                                        :placeholder="
                                            searchType === 'dni'
                                                ? 'DNI'
                                                : 'Numero de teléfono'
                                        "
                                        filled
                                        rounded
                                        autofocus
                                    ></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="mx-2">
                    <v-spacer></v-spacer>
                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="closeSearchDialog"
                        >
                            Cancelar
                        </v-btn>
                    </v-hover>

                    <v-hover v-slot:default="{ hover }">
                        <v-btn
                            rounded
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="handleSubmit(submitSearch)"
                        >
                            Buscar
                        </v-btn>
                    </v-hover>
                </v-card-actions>
            </v-card>
        </ValidationObserver>
    </v-dialog>
</template>

<script>
export default {
    props: {
        isOpenSearchDialog: {
            type: Boolean
        },
        isOpenRegisters: {
            type: Boolean
        }
    },
    data() {
        return {
            searchType: "dni",
            searchQueryDialog: null
        };
    },
    watch: {
        isOpenRegisters(val) {
            if (!val) this.searchQueryDialog = null;
        }
    },
    methods: {
        closeSearchDialog() {
            this.$emit("close:dialog");
        },
        submitSearch() {
            const payload = { [this.searchType]: this.searchQueryDialog };
            this.$emit("submit:search", payload);
        }
    }
};
</script>

<style></style>
